import React from 'react'
import Pagecontainer from '../Pagecontainer'

const Managermsg = () => {
    return (
        <>
            <Pagecontainer>
                <div className='flex flex-col items-center justify-center mt-10 mb-10'>
                    <h3 className='text-primary text-center font-sans text-2xl font-bold uppercase'>
                        Manager's Commitment {' '}
                        <p className='font-vesper text-base font-medium text-red-700 mt-2'>
                            प्रबन्धकको प्रतिवद्धता
                        </p>
                    </h3>
                    <div className='w-[30px] bg-primary h-[4px] my-2' />
                </div>
                <div className='flex gap-5 md:gap-0 flex-col md:flex-row border w-full p-5 justify-between items-center bg-primary bg-opacity-5'>
                    <div className='md:w-[82%]'>
                        <p className='font-vesper text-justify'>
                            आबद्ध बचत तथा ऋण सहकारी संस्था लि. लामो समयको विभिन्न आरोह अवरोहहरु पार गर्दै सम्पुर्ण सदस्यहरुको संस्थाप्रतिको अगाध स्नेह, विश्वास, भरोसा, माया र सहयोगका कारणले झापा जिल्लाकै एक अब्बल संस्थाको रुपमा पहिचान कायम गर्न सफल भएको छ। यस अवधिमा संस्था सदस्यहरुले सुनिश्चित भएर बचत तथा ऋण कारोबार गर्नसक्ने सवल र सुरक्षित वित्तीय संस्थाको भरपर्दो विकल्प बन्न सफल भएको छ। संस्थालाई पहिलो रोजाईको संस्था बनाउने प्रयासस्वरुप सदस्यहरुको सन्तुष्टि र गुणस्तरीय सेवा प्रदानलाई प्राथमिकतामा राख्दै सोही अनुरुप ब्यवस्थापन प्रणालीलाई विकास गर्दै लगिएको छ। अझै प्रभावकारी ब्यवस्थापनको लागि सम्पूर्ण सदस्य तथा शुभचिन्तकहरुमा रचनात्मक सल्लाह सुझाव प्रदान गरी मार्गनिर्देशन गरी दिनुहुन अनुरोध छ। हामी सम्पूर्ण कर्मचारीहरु सदैव संस्थामा आवद्ध सदस्यहरुको आवश्यकता र सन्तुष्टिमा केन्द्रीत भई गुणस्तरीय सेवा सुविधा सहज रुपमा उपलब्ध गराउन प्रतिवद्ध छौं।
                        </p>
                    </div>
                    <div className='md:w-[18%] flex md:flex-col gap-5 items-center justify-center'>
                        <img
                            className='md:w-[60%] w-[30%] rounded-full ring-4 ring-primary p-[2px]'
                            src={require('../../assets/members/manager.jpg')}
                            alt='manager'
                        />
                        <p className='text-center text-primary font-vesper'>
                            <a className='hover:underline' href='https://www.facebook.com/parbatsparsha' target='_blank'>
                                पर्वत राज चिमरिया
                            </a>
                            <br />
                            <span className='text-black text-opacity-70 text-sm'>
                                प्रबन्धक, आबद्ध साकोस लि.
                            </span>
                        </p>
                    </div>
                </div>
            </Pagecontainer>
        </>
    )
}

export default Managermsg